import { render } from "./card-model.vue?vue&type=template&id=d6e36c54&scoped=true"
import script from "./card-model.vue?vue&type=script&lang=js"
export * from "./card-model.vue?vue&type=script&lang=js"

import "./card-model.vue?vue&type=style&index=0&id=d6e36c54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e36c54"]])

export default __exports__